/** @returns {number} Non-negative open spots from Jackrabbit row data. */
export const getOpeningsCount = (openings) => {
  const value = openings?.calculated_openings;
  if (value === null || value === undefined || value === "") return 0;
  const parsed = Number(value);
  if (Number.isNaN(parsed)) return 0;
  return Math.max(0, parsed);
};

/**
 * Enrollment urgency from live Jackrabbit openings.
 * @returns {{
 *   level: "none"|"medium"|"high"|"full",
 *   spots: number,
 *   message: string|null,
 *   actionHint: string|null,
 *   registerLabel: string,
 *   rowClassName: string|null,
 * }}
 */
export const getClassUrgency = (openings) => {
  const spots = getOpeningsCount(openings);

  if (spots === 0) {
    return {
      level: "full",
      spots,
      message: "Popular class — currently full",
      actionHint: "Join the waitlist to be notified",
      registerLabel: "Waitlist",
      rowClassName: null,
    };
  }

  if (spots === 1) {
    return {
      level: "high",
      spots,
      message: "Only 1 spot left",
      actionHint: "Register soon to hold your spot",
      registerLabel: "Register",
      rowClassName: "class-schedule__row--high",
    };
  }

  if (spots === 2) {
    return {
      level: "high",
      spots,
      message: "Only 2 spots left",
      actionHint: "Register soon to hold your spot",
      registerLabel: "Register",
      rowClassName: "class-schedule__row--high",
    };
  }

  if (spots <= 4) {
    return {
      level: "medium",
      spots,
      message: "Almost full",
      actionHint: null,
      registerLabel: "Register",
      rowClassName: "class-schedule__row--medium",
    };
  }

  return {
    level: "none",
    spots,
    message: null,
    actionHint: null,
    registerLabel: "Register",
    rowClassName: null,
  };
};

export const isUrgentClass = (openings) => {
  const { level } = getClassUrgency(openings);
  return level === "high" || level === "medium";
};

/**
 * Summarize urgency across filtered class rows (for filter panel nudge).
 * @param {Array<object>} rows
 */
export const summarizeClassUrgency = (rows) => {
  const source = Array.isArray(rows) ? rows : [];
  let highCount = 0;
  let mediumCount = 0;

  source.forEach((row) => {
    const { level } = getClassUrgency(row.openings);
    if (level === "high") highCount += 1;
    if (level === "medium") mediumCount += 1;
  });

  if (highCount === 0 && mediumCount === 0) return null;

  return { highCount, mediumCount };
};
